import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

const prefix = '/admin/referrals'

// ─── Reward Tiers ───────────────────────────────────────────
export const rewardTierList = (params = '') => Http.get(`${prefix}/reward-tiers${serialize(params)}`)
export const rewardTierCreate = params => Http.post(`${prefix}/reward-tiers`, params)
export const rewardTierUpdate = params => Http.post(`${prefix}/reward-tiers/${params.id}`, params)
export const rewardTierDestroy = params => Http.delete(`${prefix}/reward-tiers/${params.id}`)

// ─── Conversions ────────────────────────────────────────────
export const conversionList = (params = '') => Http.get(`${prefix}/conversions${serialize(params)}`)

// ─── Reward Grants ──────────────────────────────────────────
export const grantList = (params = '') => Http.get(`${prefix}/grants${serialize(params)}`)
export const grantRevoke = (id, reason) => Http.post(`${prefix}/grants/${id}/revoke`, { reason })
